// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__UeCrD","approved":"Status_approved__2Lw90","rejected":"Status_rejected__2v3DA","expired":"Status_expired__pSW_Y","label":"Status_label__3jmI3"};